<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:5%;height: 90%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form :form="form" id="functionModal">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典名称">
            <a-input placeholder="请输入字典名称" v-decorator.trim="[ 'dictName', validatorRules.dictName]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典编码">
            <a-input placeholder="请输入字典编码" v-decorator.trim="[ 'dictCode', validatorRules.dictCode]"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
            <a-select v-decorator.trim="[ 'status', validatorRules.status]">
              <a-select-option value="0">正常</a-select-option>
              <a-select-option value="1">停用</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
      <function-tree-modal ref="functionTreeModal" @ok="functionTreeModalOk"></function-tree-modal>
    </a-modal>
  </div>
</template>

<script>
  import pick from 'lodash.pick'
  import { addCodeDict, editCodeDict } from '@/api/identifierCode/identifierCode'
  import {autoJumpNextInput} from "@/utils/util"
  import { mixinDevice } from '@/utils/mixin'
  export default {
    name: 'CodeDictModal',
    mixins: [ mixinDevice ],
    props: {
      current: { type: Array, required: true }
    },
    data() {
      return {
        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          dictName:{
            rules: [
              { required: true, message: '请输入字典名称！' }
            ]
          },
          dictCode:{
            rules: [
              { required: true, message: '请输入字典编码！' }
            ]
          },
          status:{
            rules: [
              { required: true, message: '请选择状态！' }
            ]
          }
        }
      }
    },
    methods: {
      onChange(checked) {
        this.model.enabled = checked
      },
      add () {
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
      },
      edit (record) {
        console.log('这是嘛？')
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.uuid){
          this.jselectMultiple.value = record.pushBtn

          this.$nextTick(() => {
            this.form.setFieldsValue(pick( this.model, 'dictName', 'dictCode', 'status' ))
            autoJumpNextInput('codeDictModal')
          });
        } else {
          this.jselectMultiple.value = ''

          this.model = {
            status: '0',
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick( this.model, 'status' ))
            autoJumpNextInput('codeDictModal')
          })
        }
        
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            formData.pushBtn = this.jselectMultiple.value
            let obj;
            if(!this.model.uuid){
              // 删除表单多余字段
              delete formData.enabled
              delete formData.pushBtn

              if ( this.current[0] === 'enterpriseDict' ) {
                // 企业规则
                formData.isStandard = 1
              } else {
                // 标准规则
                formData.isStandard = 0
              }

              obj = addCodeDict( formData );
            }else{
              obj=editCodeDict( formData );
            }
            obj.then((res)=>{
              if(res.code === 200){
                that.$emit('ok');
              }else{
                that.$message.warning(res.data.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateNumber(rule, value, callback){
        let params = {
          number: value,
          id: this.model.id?this.model.id:0
        };
        checkNumber(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("编号已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      validateName(rule, value, callback){
        let params = {
          name: value,
          id: this.model.id?this.model.id:0
        };
        checkFunction(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("名称已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      onSearchParentNumber() {
        this.$refs.functionTreeModal.edit(this.model.id);
        this.$refs.functionTreeModal.title = "选择上级编号";
        this.$refs.functionTreeModal.disableSubmit = false;
      },
      functionTreeModalOk(number, name) {
        this.form.setFieldsValue({'parentNumber': number, 'parentName': name})
      }
    }
  }
</script>